export const getBundleConfig = (items) => {
    if (!Array.isArray(items)) {
        items = [];
    }
    return {
        blocks: items.filter(({ type }) => type !== "multi"),
        sticks: items.filter(({ type }) => type === "multi"),
    };
};
//# sourceMappingURL=getBundleConfig.js.map